<div class="carrossel-content">
  <ng-container *ngIf="imagens && imagens.length > 0">
    <img [src]="imagens[indexImagemAtiva]?.file" alt="" />
  </ng-container>
</div>

<div class="botoes-controle" *ngIf="!renovabio && imagens && imagens.length > 1">
  <button
    *ngFor="let imagem of imagens; index as i"
    [class.ativo]="i === indexImagemAtiva"
    (click)="ativarImagem(i)"
  ></button>
</div>
